import script from "./StatsCards.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsCards.vue?vue&type=script&setup=true&lang=js"

import "./StatsCards.vue?vue&type=style&index=0&id=50064ab0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50064ab0"]])

export default __exports__